import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import apiClient from '../api/client';
import { ShieldCheck, Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiClient.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      // Always show success to prevent email enumeration
      setSent(true);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-soem-bg flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="w-10 h-10 bg-soem-primary rounded-sm flex items-center justify-center">
            <ShieldCheck size={22} className="text-white" />
          </div>
          <span className="text-soem-navy font-black text-2xl" style={{ fontFamily: 'Chivo, sans-serif' }}>SOEM</span>
        </div>

        <div className="soem-card p-8 animate-fade-in">
          {!sent ? (
            <>
              <h2 className="text-2xl font-bold text-soem-navy mb-2">¿Olvidaste tu contraseña?</h2>
              <p className="text-slate-500 text-sm mb-6">
                Ingresa tu correo y te enviaremos instrucciones para restablecer tu contraseña.
              </p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label htmlFor="f-correo-electrónico" className="soem-label block mb-1.5">Correo electrónico</label>
                  <div className="relative">
                    <Mail size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                    <input id="f-correo-electrónico" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                      className="w-full pl-9 pr-4 py-2.5 border border-slate-300 rounded-sm text-sm focus:outline-none focus:ring-2 focus:ring-soem-primary"
                      placeholder="usuario@soem.com" required data-testid="forgot-email-input" />
                  </div>
                </div>
                <button type="submit" disabled={loading}
                  className="w-full soem-btn-primary py-2.5 text-sm flex items-center justify-center gap-2 disabled:opacity-60"
                  data-testid="forgot-submit-btn">
                  {loading ? <><span className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent" /> Enviando...</> : 'Enviar instrucciones'}
                </button>
              </form>
            </>
          ) : (
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle size={32} className="text-green-600" />
              </div>
              <h2 className="text-xl font-bold text-soem-navy mb-2">¡Correo enviado!</h2>
              <p className="text-slate-500 text-sm mb-6">
                Si tu email está registrado, recibirás un correo con instrucciones para restablecer tu contraseña.
              </p>
              <p className="text-slate-400 text-xs">Revisa también tu carpeta de spam.</p>
            </div>
          )}

          <div className="mt-6 text-center">
            <Link to="/login" className="text-soem-primary text-sm font-semibold hover:underline flex items-center justify-center gap-1">
              <ArrowLeft size={14} /> Volver al inicio de sesión
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
